import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "league-winner",
    templateUrl: "./league-winner.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueWinnerComponent {
    @Input() public leagueName: string;

    @Input() public contestantName: string;

    @Input() public hasTrusted: boolean;

    @Input() public hasPremium: boolean;

    @Input() public image: string;
}
